import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import "./App.css";
import LandingFooter from "./Footer";
import "./style/reset.css";
import Lottie from "react-lottie-player";

const dev = false; // false 로 바꾸고 prod 빌드 하기
const base = dev ? "" : "/league";

function App() {
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  console.log(`m: ${isMobile}`);

  const source = new URLSearchParams(window.location.search).get(
    "source"
  );

  console.log(`s: ${source}`);

  // 토스트 띄우기
  const notify = () => toast("링크가 복사됐어요");

  const SHARE_URL = "https://invite.domino.is/league?source=share";
  const deeplink = source === "share"
      ? `https://dominoapp.onelink.me/vY2c/stl0jvdq` // 앱에서 오는 경우 share (복사/공유)
      : `https://dominoapp.onelink.me/vY2c/3huya9kx` // 광고로 오는 경우
      // https://dominoapp.onelink.me/vY2c/erkhlh2g // 데스크탑 용 (QR 코드로 공유 됨)

  const copyTextToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("Text copied to clipboard:", text);
        notify();
        // 복사가 성공했을 때의 처리를 추가할 수 있습니다.
      })
      .catch((error) => {
        console.error("Error copying text to clipboard:", error);
        // 복사 실패 시의 처리를 추가할 수 있습니다.
      });
  };

  const handleCopyToClipboard = () => {
    copyTextToClipboard(SHARE_URL);
  };

  const webShareUrl = async () => {
    const url: string = SHARE_URL;
    const shareData = {
      title: "총 상금 1억 투자리그",
      text: "주식 제일 잘 하는 사람 찾습니다",
      url,
    };

    try {
      if (!navigator.canShare(shareData)) {
        throw new Error("데이터를 공유할 수 없습니다.");
      }
      await navigator.share(shareData);
    } catch (err) {
      console.error(err);
    }
  };

  if (isMobile) {
    return (
      <>
        <div style={{ marginTop: "32px" }}>
          <img
            src={`.${base}/images/title.png`}
            className="blockWidth100"
            alt="타이틀"
          />

          {/* 대회 날짜 */}
          <div style={{ padding: "24px" }}>
            <div className="dateText">2024.4.15 ~ 4.30</div>
          </div>

          {/* 로티 추가 필요 */}
          <div className="lottie-wrapper">
            <Lottie path={`.${base}/images/connect_account.json`} play loop />
          </div>

          <div className="textSmall">
            <p>계좌연동으로 더 쉽고 편해진</p>
          </div>
          <div className="textLarge">
            국내 최초 전 증권사
            <br />
            합산 투자대회!
          </div>

          <div style={{ padding: "24px" }}>
            <img
              className="blockWidth100"
              src={`.${base}/images/content.png`}
              alt="logo"
            />
          </div>
        </div>

        {/* 링크복사 / 공유하기 */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            marginTop: "8px",
          }}
        >
          <div className="shareCopyWrap">
            <img
              src={`.${base}/images/copy.png`}
              alt="링크복사"
              style={{ width: "60px", borderRadius: "50%", cursor: "pointer" }}
              onClick={handleCopyToClipboard}
            />
            <span className="shareCopyText">링크복사</span>
          </div>
          <div className="shareCopyWrap">
            <img
              src={`.${base}/images/share.png`}
              alt="공유하기"
              style={{ width: "60px", borderRadius: "50%", cursor: "pointer" }}
              onClick={webShareUrl}
            />
            <span className="shareCopyText">공유하기</span>
          </div>
        </div>

        <div style={{ marginTop: "40px" }}>
          <a href={deeplink}>
            <img
              src={`.${base}/images/ranking_head.png`}
              className="blockWidth100"
              alt="ranking"
            />
          </a>
        </div>
        <div>
          <img
            src={`.${base}/images/ranking.png`}
            className="blockWidth100"
            alt="ranking"
          />
        </div>

        <div style={{ marginTop: "40px" }}>
          <img
            src={`.${base}/images/notice.png`}
            className="footerBox"
            alt="logo"
          />
        </div>
        <LandingFooter />

        {/* 플로팅 버튼 */}
        <div className="fixed-bottom-container">
          <a href={deeplink}>
            <div className="rounded-button">참가 신청하고 내 순위 확인하기</div>
          </a>
        </div>
        <ToastContainer
          position="bottom-center"
          className="toastContainer"
          toastClassName="toast"
          bodyClassName="toastBody"
          newestOnTop={false}
          autoClose={2000}
          hideProgressBar={true}
          transition={Slide}
          closeButton={false}
        />
      </>
    );
  } else {
    return (
      <>
        <div className="desktop">
          {
            ["01", "02", "03", "04", "05", "06"].map(name => (
              <img style={{ marginBottom: "24px" }}
                src={`.${base}/images/desktop/${name}.png`}
                className="desktopImg"
                alt=""
                onClick={() => {
                  if (name === "05") {
                    toast("앱에서 확인할 수 있어요");
                  }
                } } />
            ))
          }
        </div>
        <LandingFooter />
        <ToastContainer
          position="bottom-center"
          className="toastContainer"
          toastClassName="toast"
          bodyClassName="toastBody"
          newestOnTop={false}
          autoClose={2000}
          hideProgressBar={true}
          transition={Slide}
          closeButton={false}
        />
      </>
    );
  }
}

export default App;
